import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import type { DashboardTrendPoint } from "@/api/dashboard";
import { Card } from "@/components/ui/card";

type Props = {
  title: string;
  subtitle: string;
  data: DashboardTrendPoint[];
  dataKeyLabel: string;
};

export function ChurchTrendsCard({
  title,
  subtitle,
  data,
  dataKeyLabel,
}: Props) {
  return (
    <Card className="h-full p-6">
      <div>
        <h2 className="text-xl font-semibold text-white">
          {title}
        </h2>

        <p className="mt-1 text-sm text-slate-500">
          {subtitle}
        </p>
      </div>

      {data.length === 0 ? (
        <div className="mt-6 flex h-64 items-center justify-center rounded-2xl border border-dashed border-slate-700 bg-slate-950/40">
          <p className="text-sm text-slate-400">
            No trend data available.
          </p>
        </div>
      ) : (
        <div className="mt-6 h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={data}
              margin={{
                top: 12,
                right: 12,
                left: -18,
                bottom: 0,
              }}
            >
              <defs>
                <linearGradient
                  id={`trend-${dataKeyLabel}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor="#818cf8"
                    stopOpacity={0.4}
                  />
                  <stop
                    offset="95%"
                    stopColor="#818cf8"
                    stopOpacity={0.02}
                  />
                </linearGradient>
              </defs>

              <CartesianGrid
                stroke="#1e293b"
                strokeDasharray="4 4"
                vertical={false}
              />

              <XAxis
                dataKey="label"
                stroke="#64748b"
                tickLine={false}
                axisLine={false}
                tick={{ fontSize: 12 }}
              />

              <YAxis
                stroke="#64748b"
                tickLine={false}
                axisLine={false}
                tick={{ fontSize: 12 }}
                allowDecimals={false}
              />

              <Tooltip
                contentStyle={{
                  background: "#020617",
                  border: "1px solid #1e293b",
                  borderRadius: "14px",
                  color: "#fff",
                }}
              />

              <Area
                type="monotone"
                dataKey="value"
                name={dataKeyLabel}
                stroke="#818cf8"
                strokeWidth={3}
                fill={`url(#trend-${dataKeyLabel})`}
                dot={{
                  r: 4,
                  fill: "#818cf8",
                  strokeWidth: 0,
                }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
}